/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {startAccountRecovery} from '../api'

export const useMutationStartAccountRecovery = createReactQueryMutationHook('startAccountRecovery', startAccountRecovery)
